import { Create, SelectInput, SimpleForm, TextInput } from 'react-admin';
import { SPORT_TYPES_INPUT } from '../../constant';

export const TeamCreate = () => (
    <Create redirect="list">
        <SimpleForm>
            <TextInput source="name" required/>
            <SelectInput source="type" choices={SPORT_TYPES_INPUT} required />
        </SimpleForm>
    </Create>
);